import { Reveal } from "./Reveal";
import { MACHINES, fmt } from "@/lib/pricing";
import { usePricing } from "@/hooks/usePricing";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
};

const FEATURES = [
  { t: "Önfeltekerő kötélrendszer", d: "Az önfeltekerő kötéldobok és önzáró rögzítők gyors, egyszerű és precíz kötélállítást tesznek lehetővé edzés közben." },
  { t: "Neoprén rugóhuzatok", d: "Csökkentik a zajt, egyenletes rugónyúlást biztosítanak, és biztos fogást adnak a rugók cseréjekor." },
  { t: "Komfort lábtartó rúd", d: "A párnázott lábtartó kényelmesebb, és kevésbé terheli a kezet és a lábfejet gyakorlás közben." },
  { t: "Csúszásgátló talpak", d: "A tartós szilikongumi és PVC talpak jól tapadnak, és minden padlón stabilan a helyén tartják a reformert." },
];

const products = [
  {
    key: "reformer",
    badge: "Legnépszerűbb stúdió alapgép",
    desc: "Legkelendőbb reformerünk, az egészségügyi és fitnesz szakemberek kedvence. Boutique stúdiók és kifejezetten pilatesre szánt termek számára készült.",
  },
  {
    key: "feltornyos",
    badge: "Terápia és rehabilitáció",
    desc: "A féltornyos reformer terápiás és rehabilitációs célokra készült. A reformerre Vertical Frame (függőleges keret) szerelhető, amely a gyakorlattárat jóval a reformer-gyakorlatokon túlra bővíti.",
  },
];

export const Products = () => {
  const pricing = usePricing();
  return (
  <section id="gepek" className="py-24 lg:py-32 bg-[var(--stone-bg)]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <h2 className="font-serif-d font-medium text-2xl sm:text-3xl lg:text-4xl leading-tight">
          Reformerek
        </h2>
      </Reveal>
      <div className="mt-12 grid md:grid-cols-2 gap-8">
        {products.map((p, i) => (
          <Reveal key={p.key} delay={i * 0.12}>
            <article
              data-testid={`product-card-${p.key}`}
              className="group bg-white border border-[var(--line)] rounded-3xl p-9 flex flex-col h-full hover:border-[var(--terra)]/50 transition-colors duration-300"
            >
              <span className="eyebrow text-[var(--terra)]">{p.badge}</span>
              <div className="mt-5 flex items-baseline justify-between gap-4">
                <h3 className="font-serif-d font-semibold text-2xl">{MACHINES[p.key].label}</h3>
                <p className="font-serif-d text-xl text-[var(--terra)] whitespace-nowrap">
                  {fmt(pricing.price_table[p.key].lease_12.down)}-tól
                </p>
              </div>
              <p className="mt-4 text-[var(--ink-soft)] leading-relaxed text-sm">{p.desc}</p>
              <ul className="mt-6 space-y-3.5 border-t border-[var(--line)] pt-6">
                {FEATURES.map((f) => (
                  <li key={f.t} className="flex items-start gap-2.5">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[var(--terra)] shrink-0" />
                    <p className="text-xs text-[var(--ink-soft)] leading-relaxed">
                      <span className="font-semibold text-[var(--ink)]">{f.t}</span> – {f.d}
                    </p>
                  </li>
                ))}
              </ul>
              <button
                data-testid={`product-cta-${p.key}`}
                onClick={() => scrollTo("kalkulator")}
                className="mt-8 btn-terra rounded-full px-6 py-3 text-sm font-semibold self-start"
              >
                Kalkuláció erre a gépre →
              </button>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
